import React, { useEffect, useState } from 'react';
import { Card, CardBody, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Modal, ModalBody, ModalHeader, CardHeader } from "reactstrap";

import avatar10 from "../../../../../assets/images/users/avatar-10.jpg";
import avatar8 from "../../../../../assets/images/users/avatar-8.jpg";
import avatar2 from "../../../../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../../../assets/images/users/avatar-4.jpg";
import avatar7 from "../../../../../assets/images/users/avatar-7.jpg";

import { Link } from 'react-router-dom';
import dayjs from 'dayjs';


const TimeTracking = ({ data }) => {
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    return (
        <React.Fragment>
            <Card className="mb-3">
                <CardHeader className='p-2 align-items-center d-flex'><h5 className="card-title mb-0 flex-grow-1">Establecimiento</h5></CardHeader>
                <CardBody>
                    <div className="table-card">
                        <table className="table mb-0">
                            <tbody>
                                <tr>
                                    <td className="text-muted w-50">Establecimiento</td>
                                    <td className="fw-semibold">{data?.establishment.name}</td>
                                </tr>
                                <tr>
                                    <td className="text-muted">Ciclo Productivo</td>
                                    <td className="fw-semibold">{data?.productive_cycle.code}</td>
                                </tr>
                                <tr>
                                    <td className="text-muted">Etapa de Ciclo Productivo</td>
                                    <td className="fw-semibold">{data?.productive_cycle_stage.name}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </CardBody>
            </Card>

            <Card className="mb-3">
                <CardHeader className='p-2 align-items-center d-flex'><h5 className="card-title mb-0 flex-grow-1">Actividad</h5></CardHeader>
                <CardBody>
                    <div className="table-card">
                        <table className="table mb-0">
                            <tbody>
                                <tr>
                                    <td className="text-muted w-50">Tipo de Actividad</td>
                                    <td className="fw-semibold">{data?.activity_type.name}</td>
                                </tr>
                                <tr>
                                    <td className="text-muted">Prioridad de Actividad</td>
                                    <td>
                                        <span className='badge fw-medium fs-11' style={{ backgroundColor: data?.activity_priority.bgcolor, color: data?.activity_priority.txcolor }}>
                                            <i className={`align-middle ${data?.activity_priority.icon}`}></i> {data?.activity_priority.name}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-muted">Estado de Actividad</td>
                                    <td>
                                        <span className='badge fw-medium fs-11' style={{ backgroundColor: data?.activity_status.bgcolor, color: data?.activity_status.txcolor }}>
                                            <i className={`align-middle ${data?.activity_status.icon}`}></i> {data?.activity_status.name}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-muted">Periodicidad</td>
                                    <td className="fw-semibold">{data?.periodicity.name}</td>
                                </tr>
                                <tr>
                                    <td className="text-muted">Inicio</td>
                                    <td className="fw-semibold">
                                        {
                                            data?.start
                                                ? dayjs(data.start).format('DD-MM-YYYY HH:mm')
                                                : ''
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-muted">Fin</td>
                                    <td className="fw-semibold">
                                        {
                                            data?.end
                                                ? dayjs(data.end).format('DD-MM-YYYY HH:mm')
                                                : ''
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-muted">Grupo de Actividad</td>
                                    <td>
                                        <span className='badge fw-medium fs-11' style={{ backgroundColor: data?.activity_group.bgcolor, color: data?.activity_group.txcolor }}>
                                            <i className={`align-middle ${data?.activity_group.icon}`}></i> {data?.activity_group.name}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </CardBody>
            </Card>

            <div className="card mb-3">
                <div className="card-body">
                    <div className="d-flex mb-3">
                        <h6 className="card-title mb-0 flex-grow-1">Participantes</h6>
                        <div className="flex-shrink-0">
                            <button type="button" onClick={toggle} className="btn btn-soft-danger btn-sm" data-bs-toggle="modal" data-bs-target="#inviteMembersModal"><i className="ri-share-line me-1 align-bottom"></i> Asignar</button>
                        </div>
                    </div>
                    <ul className="list-unstyled vstack gap-3 mb-0">
                        <li>
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0">
                                    <img src={avatar10} alt="" className="avatar-xs rounded-circle" />
                                </div>
                                <div className="flex-grow-1 ms-2">
                                    <h6 className="mb-1"><Link to="/pages-profile">Rosita Retamal</Link></h6>
                                    <p className="text-muted mb-0">Coordinadora</p>
                                </div>
                                <div className="flex-shrink-0">
                                    <UncontrolledDropdown>
                                        <DropdownToggle tag="button" className="btn btn-icon btn-sm fs-16 text-muted dropdown" type="button">
                                            <i className="ri-more-fill"></i>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <div><DropdownItem><i className="ri-eye-fill text-muted me-2 align-bottom"></i>View</DropdownItem></div>
                                            <div><DropdownItem><i className="ri-star-fill text-muted me-2 align-bottom"></i>Favourite</DropdownItem></div>
                                            <div><DropdownItem><i className="ri-delete-bin-5-fill text-muted me-2 align-bottom"></i>Delete</DropdownItem></div>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0">
                                    <img src={avatar8} alt="" className="avatar-xs rounded-circle" />
                                </div>
                                <div className="flex-grow-1 ms-2">
                                    <h6 className="mb-1"><Link to="/pages-profile">Juan Pablo Lopez</Link></h6>
                                    <p className="text-muted mb-0">Encargado de Centro</p>
                                </div>
                                <div className="flex-shrink-0">
                                    <UncontrolledDropdown>
                                        <DropdownToggle tag="button" className="btn btn-icon btn-sm fs-16 text-muted dropdown" type="button">
                                            <i className="ri-more-fill"></i>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <div><DropdownItem><i className="ri-eye-fill text-muted me-2 align-bottom"></i>View</DropdownItem></div>
                                            <div><DropdownItem><i className="ri-star-fill text-muted me-2 align-bottom"></i>Favourite</DropdownItem></div>
                                            <div><DropdownItem><i className="ri-delete-bin-5-fill text-muted me-2 align-bottom"></i>Delete</DropdownItem></div>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0">
                                    <img src={avatar2} alt="" className="avatar-xs rounded-circle" />
                                </div>
                                <div className="flex-grow-1 ms-2">
                                    <h6 className="mb-1"><Link to="/pages-profile">Margarita Muñoz</Link></h6>
                                    <p className="text-muted mb-0">Resposable de Reportabilidad</p>
                                </div>
                                <div className="flex-shrink-0">
                                    <UncontrolledDropdown>
                                        <DropdownToggle tag="button" className="btn btn-icon btn-sm fs-16 text-muted dropdown" type="button">
                                            <i className="ri-more-fill"></i>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <div><DropdownItem><i className="ri-eye-fill text-muted me-2 align-bottom"></i>View</DropdownItem></div>
                                            <div><DropdownItem><i className="ri-star-fill text-muted me-2 align-bottom"></i>Favourite</DropdownItem></div>
                                            <div><DropdownItem><i className="ri-delete-bin-5-fill text-muted me-2 align-bottom"></i>Delete</DropdownItem></div>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <Modal isOpen={modal} toggle={toggle} centered className="border-0">
                <ModalHeader toggle={toggle} className="p-3 ps-4">
                    Participantes
                </ModalHeader>
                <ModalBody className="modal-body p-4">
                    <div className="search-box mb-3">
                        <input type="text" className="form-control bg-light border-light" placeholder="Search here..." />
                        <i className="ri-search-line search-icon"></i>
                    </div>

                    <div className="mb-4 d-flex align-items-center">
                        <div className="me-2">
                            <h5 className="mb-0 fs-13">Miembros :</h5>
                        </div>
                        <div className="avatar-group justify-content-center">
                            <Link to="#" className="avatar-group-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Tonya Noble">
                                <div className="avatar-xs">
                                    <img src={avatar10} alt="" className="rounded-circle img-fluid" />
                                </div>
                            </Link>
                            <Link to="#" className="avatar-group-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Thomas Taylor">
                                <div className="avatar-xs">
                                    <img src={avatar8} alt="" className="rounded-circle img-fluid" />
                                </div>
                            </Link>
                            <Link to="#" className="avatar-group-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Nancy Martino">
                                <div className="avatar-xs">
                                    <img src={avatar2} alt="" className="rounded-circle img-fluid" />
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="mx-n4 px-4" style={{ maxHeight: "225px" }}>
                        <div className="vstack gap-3">
                            <div className="d-flex align-items-center">
                                <div className="avatar-xs flex-shrink-0 me-3">
                                    <img src={avatar2} alt="" className="img-fluid rounded-circle" />
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-13 mb-0"><Link to="#" className="text-body d-block">Nancy Martino</Link></h5>
                                </div>
                                <div className="flex-shrink-0">
                                    <button type="button" className="btn btn-light btn-sm">Agregar</button>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="avatar-xs flex-shrink-0 me-3">
                                    <div className="avatar-title bg-danger-subtle text-danger rounded-circle">
                                        HB
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-13 mb-0"><Link to="#" className="text-body d-block">Henry Baird</Link></h5>
                                </div>
                                <div className="flex-shrink-0">
                                    <button type="button" className="btn btn-light btn-sm">Agregar</button>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="avatar-xs flex-shrink-0 me-3">
                                    <img src={avatar3} alt="" className="img-fluid rounded-circle" />
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-13 mb-0"><Link to="#" className="text-body d-block">Frank Hook</Link></h5>
                                </div>
                                <div className="flex-shrink-0">
                                    <button type="button" className="btn btn-light btn-sm">Agregar</button>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="avatar-xs flex-shrink-0 me-3">
                                    <img src={avatar4} alt="" className="img-fluid rounded-circle" />
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-13 mb-0"><Link to="#" className="text-body d-block">Jennifer Carter</Link></h5>
                                </div>
                                <div className="flex-shrink-0">
                                    <button type="button" className="btn btn-light btn-sm">Agregar</button>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="avatar-xs flex-shrink-0 me-3">
                                    <div className="avatar-title bg-success-subtle text-success rounded-circle">
                                        AC
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fs-13 mb-0"><Link to="#" className="text-body d-block">Alexis Clarke</Link></h5>
                                </div>
                                <div className="flex-shrink-0">
                                    <button type="button" className="btn btn-light btn-sm">Agregar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <div className="modal-footer">
                    <button type="button" className="btn btn-light w-xs" data-bs-dismiss="modal">Cancelar</button>
                    <button type="button" className="btn btn-success w-xs">Asignar</button>
                </div>
            </Modal>
        </React.Fragment>
    );
};

export default TimeTracking;